/* eslint-disable no-restricted-imports */

import { observer } from 'mobx-react';
import { forwardRef } from 'react';

import { ApiResult } from '@api/base/models/ApiResult';
import { apiIsLoading } from '@api/base/utils';
import {
	SpinnerProps as FluentSpinnerProps,
	ForwardRefComponent,
	renderSpinner_unstable as renderSpinner,
	useSpinner_unstable as useSpinner,
	useSpinnerStyles_unstable as useSpinnerStyles,
} from '@fluentui/react-components';
import { t } from '@shared/i18n';
import { useCustomSpinnerStyles } from './Spinner.styles';

export type SpinnerProps = FluentSpinnerProps & { watch?: ApiResult<unknown> | Array<ApiResult<unknown>> };

export const Spinner: ForwardRefComponent<SpinnerProps> = forwardRef<HTMLDivElement, SpinnerProps>((props, ref) => {
	const state = useSpinner(
		{
			labelPosition: 'below', // most if not all of our spinners display the label below the spinner
			'aria-label': t('General.Loading'),
			...props,
		},
		ref,
	);
	useSpinnerStyles(state);
	useCustomSpinnerStyles(state);

	if (!props?.watch) {
		return renderSpinner(state);
	}

	const ObserverSpinner = observer(() => {
		const { watch } = props;
		const isLoading = Array.isArray(watch) ? apiIsLoading(...watch) : watch.isLoading;

		return isLoading ? renderSpinner(state) : null;
	});

	return <ObserverSpinner />;
}) as ForwardRefComponent<SpinnerProps>;

Spinner.displayName = 'Spinner';
